/*
 * Copyright Mimic Networks, Inc. 2026.
 */

export const FLEET_NAME_MAX_LENGTH = 255;

export type NewFleetFormFields = {
  name: string;
  description?: string;
  operatingSystem: 'windows' | 'linux';
};
